import React, { useEffect, useRef } from 'react';

import { connect } from 'react-redux';

import { openSimilaritySearchDialog } from '@Pages/RetroSynthesis/SimilaritySearch/actions';
import { openSynthesisJobRetryDialog } from '@Pages/RetroSynthesis/SynthesisJobRetry/actions';
import {
  getProjectListLoading,
  getProjectsListResponse,
  getCreatedProject,
  getImportedProjects,
  getLastViewedProjectPosition,
} from '@Pages/RetroSynthesis/RetroSynthesisProjects/selectors';
import {
  fetchProjectsAction,
  renameProjectAction,
  editProjectAction,
  goToLoginAction,
  clearCreatedProjectState,
  retrySynthesisJob,
  bulkDeleteProjectsAction,
  retryMultipleSynthesisJob,
  clearImportedProjectsState,
  setViewProjectsPosition,
} from './actions';
import RetroSynthesisProjects from './RetroSynthesisProjects';
import { onImportProjects, onPageLoad } from './analytics';

/* eslint-disable no-shadow */
/* eslint-disable react-hooks/exhaustive-deps */
function RetroSynthesisProjectsContainer({
  isLoading,
  response,
  fetchProjects,
  renameProject,
  deleteProjects,
  openSimilaritySearchDialog,
  openSynthesisJobRetryDialog,
  editProject,
  goToLogin,
  createdProject,
  clearCreatedProjectState,
  retrySynthesisJob,
  retryMultipleSynthesisJob,
  importedProjects,
  clearImportedProjectsState,
  lastViewedProjectPosition,
  setViewProjectsPosition,
}) {
  const lastCreatedProjectId = useRef(null);

  useEffect(() => {
    if (createdProject) {
      lastCreatedProjectId.current = createdProject.id;
      onPageLoad(createdProject); // AA
      clearCreatedProjectState(); // Clear created project after tracking
    }
  }, [createdProject]);

  useEffect(() => {
    if (importedProjects) {
      onImportProjects(importedProjects); // AA
      clearImportedProjectsState(); // clear imported projects
      fetchProjects({}, true); // refresh projects list with liveUpdates
    }
  }, [importedProjects]);

  return (
    <RetroSynthesisProjects
      response={response}
      isLoading={isLoading}
      doFetchProjects={(params) => fetchProjects(params, true)} // liveUpdates = true
      doEditName={(projectId, projectName) => renameProject(projectId, projectName)}
      doDeleteProjects={(projectIds) => deleteProjects(projectIds)}
      doSimilaritySearch={(project) => openSimilaritySearchDialog(project)}
      openSynthesisJobRetryDialog={openSynthesisJobRetryDialog}
      doEditProject={(project) => editProject(project)}
      goToLogin={goToLogin}
      doRetrySynthesisJob={retrySynthesisJob}
      doRetryMultipleSynthesisJob={retryMultipleSynthesisJob}
      lastViewedProjectPosition={lastViewedProjectPosition}
      setViewProjectsPosition={setViewProjectsPosition}
    />
  );
}

const mapStateToProps = (state) => ({
  response: getProjectsListResponse(state),
  isLoading: getProjectListLoading(state),
  createdProject: getCreatedProject(state),
  importedProjects: getImportedProjects(state),
  lastViewedProjectPosition: getLastViewedProjectPosition(state),
});

const mapActionToProps = {
  fetchProjects: fetchProjectsAction,
  renameProject: renameProjectAction,
  deleteProjects: bulkDeleteProjectsAction,
  openSimilaritySearchDialog,
  openSynthesisJobRetryDialog,
  editProject: editProjectAction,
  goToLogin: goToLoginAction,
  clearCreatedProjectState,
  retrySynthesisJob,
  retryMultipleSynthesisJob,
  clearImportedProjectsState,
  setViewProjectsPosition,
};

export default connect(mapStateToProps, mapActionToProps)(RetroSynthesisProjectsContainer);
